import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	container: {
	},
	verticalSpacing: {
		margin: !props?.isMobile ? "0 2.5rem" : "0"
	},
	titleContianer: {
		position   : "fixed",
		top        : "70px",
		width      : "100%",
		zIndex     : "21",
		background : theme.other.colors.background.secondary,
		height     : "70px"
	},
	title: {
		fontSize      : "2rem",
		fontWeight    : "500",
		margin        : "2rem 2.5rem",
		textTransform : "capitalize !important"

	},
	headerContainer: {
		display    : "flex",
		alignItems : "center"
	},
	gameGridContainer: {
		display          : "grid",
		gridTemplateRows : props?.isMobile ? "repeat(2, 1fr)" : "1fr",
		gridAutoFlow     : "column",
		gap              : "1.5rem",
		width            : "100%",
		overflow         : "auto",
		marginBottom     : "1rem" // for horizonatal scrollbar

	},
	newsGridContainer: {
		display          : "grid",
		gap              : "1.5rem",
		width            : "100%",
		overflow         : "auto",
		marginBottom     : "1rem", // for horizonatal scrollbar
		gridAutoFlow     : "column",
		gridTemplateRows : "1fr 1fr"

	},
	gameCard: {
		textAlign: props?.isMobile ? "center" : "left"
	},
	gameImage: {
		height       : props?.isMobile ? "100px" : "150px",
		width        : props?.isMobile ? "100px" : "150px",
		borderRadius : "1rem"
	},
	gamingZoneContainer: {
		padding: props?.isMobile ? "2rem" : "2.5rem"
	},
	newsElement: {
		width: props?.isMobile ? "100%" : "400px"
	},
	newsCard: {
		display             : "grid",
		gridTemplateColumns : "1fr 3fr",
		// backgroundColor     : theme.other.colors.dialog.secondary,
		border              : `1px solid ${ theme.other.colors.border.primary }`,
		overflow            : "hidden",
		borderRadius        : "1rem",
		height              : "100px"
	},
	newsImageContainer: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center",
		overflow       : "hidden"
	},
	newsImage: {
		height    : "100%",
		objectFit : "cover",
		minWidth  : "100px",
		overflow  : "hidden"
	},
	newsText: {
		padding        : "1.5rem",
		display        : "flex",
		flexDirection  : "column",
		justifyContent : "space-between"
	},
	newsTime: {
		color      : theme.other.colors.text.secondary,
		fontWeight : "500"
	},
	seeAllButton: {
		display      : props?.isMobile ? "block" : "none",
		border       : `1.5px solid ${ theme.other.paletteNew.primaryDarkBlue }`,
		borderRadius : "1rem",
		height       : "fit-content",
		padding      : "1.2rem",
		color        : theme.other.paletteNew.primaryDarkBlue,
		"&:hover"    : {
			backgroundColor: "initial"
		},
		margin: "1rem 0"
	},
	seeAllButtonInner: {
	},
	cardListContainer: {
		paddingTop   : "calc(2.5rem + 70px)",
		marginBottom : "2.5rem"
	}

} ) );
